<template>
    <div
        class="menu-simple-controls flex items-center px-4 p-8 z-10">
        <div class="nav-box mb-6">
            <!--Menu Title-->
            <h3
                v-if="title"
                class="bg-black-700 opacity-75 text-xs font-bold uppercase text-gold-500 py-1 px-4 tracking-wider phone:text-xxs border-b border-gray-500 transition-all"
                v-html="title"
            />

            <!--Menu Items Iterator-->
            <div class="menu-items flex flex-col">
                <div
                    v-for="(year, index) in menuItems"
                    :key="index"
                    :class="{
                        'text-white border-t-2 border-gold-500': index == currentItem,
                        'text-gray-500': index != currentItem
                    }"
                    class="text-center bg-black-700 phone:p-3 p-4 text-sm font-regular uppercase tracking-widest opacity-75 border-t border-gray-500 transition-all cursor-pointer phone:text-sm"
                    @click="handleMenuItemChange(index)"
                >
                    <span class="block">{{ index }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'SectionSidebarMenuSimple',
  props: {
    title: {
      type: String,
      required: false,
    },
    currentItem: {
      type: Number,
      required: true,
    },
    handleMenuItemChange: {
      type: Function,
      required: true,
    },
    menuItems: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style scoped>
    .menu-simple-controls {
        width: 155px;
    }

</style>
